<div class="flex flex-col">
  <div class="flex flex-col justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Title</mat-label>
      <input #titleInput matInput placeholder="Survey title" [(ngModel)]="data.input.title"
             particleAnalytics
             analyticsCategory="add-survey-dialog"
             analyticsAction="Survey-title" required>
    </mat-form-field>
  </div>
  <div class="flex flex-col justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-0-100">
      <mat-label>Description</mat-label>
      <textarea matInput type="text" [(ngModel)]="data.input.description"
                placeholder="Survey Description" rows="5">
              </textarea>
    </mat-form-field>
  </div>

  <!--<div fxLayout="row" fxLayoutAlign="start start" fxFlex="0 0 auto">
    <mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
      <mat-label>Response Type </mat-label>
      <input matInput placeholder="Input" style="display: none"
             particleAnalytics
             analyticsCategory= "choice-filter-modal-item-editor"
             analyticsAction= "entity-scope-input">
      <mat-radio-group fxLayout="column"
                       aria-label="Select an option"
                       [(ngModel)]="responseType"
                       (change)="onChange($event)"
      >
        <mat-radio-button class="m-b-15" value="independent">Independent
          <div class="hint">Recipients will work independently and submit responses separately</div>
        </mat-radio-button>
        <mat-radio-button class="m-b-15" value="collaborate">Collaborative
          <div class="hint">Recipients will work collaboratively and submit a single response</div>
        </mat-radio-button>
      </mat-radio-group>

    </mat-form-field>
  </div>-->

  <div *ngIf="showAllowRecipientsOption" class="flex flex-col justify-start items-start auto-flex">
    <mat-checkbox [(ngModel)]="allowCreateNewRecord">Allow recipient(s) to add new records in their response
    </mat-checkbox>
    <!--Allow create new record(s)-->
  </div>
</div>


